import React from 'react';
import styled from 'styled-components';

import SrpCardLeftComponent from '../SrpCardLeftComponent/SrpCardLeftComponent';
import SrpCardRightComponent from '../SrpCardRightComponent/SrpCardRightComponent';

const SrpCardAllComponent = () => (
  <>
    <SrpCardAllComponentWrapDiv>
      <SrpCardLeftComponent></SrpCardLeftComponent>
      <SrpCardRightComponent></SrpCardRightComponent>
    </SrpCardAllComponentWrapDiv>
  </>
);

export default SrpCardAllComponent;

const SrpCardAllComponentWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    max-width: 94rem;
    margin: 0 auto;
    width:100%;
    background-color:${props.theme.colors.white.base};
    border-radius:${props.theme.misc.borderRadius.xlarge};
    margin-top:${props.theme.spacing.large.l20};
  `
);
